// AWS Amplify Configuration
// Auto-generated by setup-cognito-automated.js
// Last updated: 2026-01-04T12:30:43.840Z

const awsConfig = {
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1',

    // REQUIRED - Amazon Cognito User Pool ID
    userPoolId: 'us-east-1_Or2GTashH',

    // REQUIRED - Amazon Cognito Web Client ID (App Client ID)
    userPoolWebClientId: '2muommqh15qvsflt8umb9qn0nb',

    // OPTIONAL - Authentication flow type
    authenticationFlowType: 'USER_SRP_AUTH',
  }
};

export default awsConfig;
